module.exports = __webpack_public_path__ + "d62fa07d7a7ab5c5082f71a4cfa88391.svg";